<div class="container" style="width: 97%; margin-top: 1rem">
  <div
    class="row"
    style="margin-bottom: auto; margin-left: auto; margin-right: auto"
  >
    <div class="col-lg-12" style="padding-left: 0px; padding-right: 0px">
      <div
        class="panel panel-primary"
        style="background: #fff; box-shadow: 4px 4px 4px #888888"
      >
        <div class="panel-heading">
          <h4 style="margin-bottom: 3px; margin-top: 5px">Add Meter</h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <form
                [formGroup]="addMeterForm"
                #formDirective="ngForm"
                (ngSubmit)="submitMeterDetails()"
                novalidate
              >
                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >Select Site<span class="iep-required"
                          >*</span
                        ></mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <mat-select
                          formControlName="siteCtr"
                          [(ngModel)]="MeterDetails.siteId"
                          (selectionChange)="SiteChange()"
                          placeholder=""
                          style="top: 12px"
                          required
                        >
                          <mat-option value="" selected
                            >Please select a Site</mat-option
                          >
                          <mat-option
                            *ngFor="let item of sites"
                            [value]="item.SiteId"
                          >
                            {{ item.SiteName }}</mat-option
                          >
                        </mat-select>
                        <mat-error
                          *ngIf="isFieldHasError('siteCtr', 'required')"
                          >This field is required.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >KPI Utility<span class="iep-required"
                          >*</span
                        ></mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <mat-label>Please Select Utility</mat-label>
                        <mat-select
                          formControlName="kpiUtilityCtr"
                          [(ngModel)]="MeterDetails.kpiUtility"
                          (selectionChange)="onUtilityChange($event)"
                          style="top: 12px"
                          required
                        >
                          <mat-option
                            *ngFor="let item of configuredKpiUtilities"
                            [value]="item"
                          >
                            {{ item }}</mat-option
                          >
                        </mat-select>
                        <mat-error
                          *ngIf="isFieldHasError('kpiUtilityCtr', 'required')"
                          >This field is required.</mat-error
                        >
                      </mat-form-field>
                    </div>
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >Select DCU<span class="iep-required"
                          >*</span
                        ></mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <mat-select
                          formControlName="dcuCtr"
                          [(ngModel)]="MeterDetails.dcuId"
                          (selectionChange)="DCUChange()"
                          placeholder=""
                          style="top: 12px"
                          required
                        >
                          <mat-option value="" selected
                            >Please Select DCU</mat-option
                          >
                          <mat-option
                            *ngFor="let item of AvailableDCU"
                            [value]="item.dcuID"
                          >
                            {{ item.dcuName }}</mat-option
                          >
                        </mat-select>
                        <mat-error *ngIf="isFieldHasError('dcuCtr', 'required')"
                          >This field is required.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >Meter Make<span class="iep-required"
                          >*</span
                        ></mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="meterMakeCtr"
                          [(ngModel)]="MeterDetails.meterMake"
                          required
                          placeholder="Meter Make"
                        />
                        <mat-error
                          *ngIf="isFieldHasError('meterMakeCtr', 'required')"
                          >This field is required.</mat-error
                        >
                      </mat-form-field>
                    </div>
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >Meter type<span class="iep-required"
                          >*</span
                        ></mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <mat-select
                          formControlName="meterTypeCtr"
                          [(ngModel)]="MeterDetails.meterType"
                          placeholder="Meter type"
                          style="top: 12px"
                          required
                        >
                          <mat-option value="" selected
                            >Please select a Meter type</mat-option
                          >
                          <mat-option
                            *ngFor="let item of ChooseMeterType"
                            [value]="item.meterType"
                            >{{ item.meterType }}</mat-option
                          >
                        </mat-select>
                        <mat-error
                          *ngIf="isFieldHasError('meterTypeCtr', 'required')"
                          >This field is required.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >Serial Number<span class="iep-required"
                          >*</span
                        ></mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="serialNumberCtr"
                          (keypress)="numberOnly($event)"
                          [(ngModel)]="MeterDetails.serialNumber"
                          type="number"
                          required
                          placeholder="Serial Number"
                        />
                        <mat-error
                          *ngIf="isFieldHasError('serialNumberCtr', 'required')"
                          >This field is required.</mat-error
                        >
                      </mat-form-field>
                    </div>

                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >Meter Role<span class="iep-required"
                          >*</span
                        ></mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <mat-select
                          formControlName="meterRoleCtr"
                          [(ngModel)]="MeterDetails.meterRole"
                          (selectionChange)="changeMeterRole()"
                          placeholder=""
                          style="top: 12px"
                          required
                        >
                          <mat-option value="" selected
                            >Please select a MeterRole</mat-option
                          >
                          <mat-option
                            *ngFor="let item of ChooseMeterRole"
                            [value]="item"
                            >{{ item }}
                          </mat-option>
                        </mat-select>
                        <mat-error
                          *ngIf="isFieldHasError('meterRoleCtr', 'required')"
                          >This field is required.</mat-error
                        >
                      </mat-form-field>
                    </div>

                    <br />
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >InSite Meter ID<span class="iep-required"
                          >*</span
                        ></mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="insiteMeteridCtr"
                          [(ngModel)]="MeterDetails.insiteMeterid"
                          (keypress)="numberOnly($event)"
                          (blur)="onInsiteMeterIDFocusOut()"
                          type="number"
                          required
                          placeholder="InSite Meter ID"
                        />
                        <mat-error
                          *ngIf="
                            isFieldHasError('insiteMeteridCtr', 'required')
                          "
                          >This field is required.</mat-error
                        >
                        <mat-error
                          *ngIf="
                            isFieldHasError('insiteMeteridCtr', 'duplicated')
                          "
                          >Insite meter ID already exist for DCU
                          {{ MeterDetails.dcuId }}.
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="col-lg-1"></div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-label class="label-input"
                        >Current Unbalance X</mat-label
                      >
                    </div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="currentUnbalanceXCtr"
                          [(ngModel)]="MeterDetails.currentUnbalanceX"
                          type="text"
                          placeholder="Enter Current Unbalance X for Meter"
                          pattern="^(\d*\.)?\d+$"
                        />
                        <mat-error
                          *ngIf="
                            isFieldHasError('currentUnbalanceXCtr', 'pattern')
                          "
                        >
                          Please input positive decimal numbers.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >Meter ID<span class="iep-required">*</span></mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="meterIdCtr"
                          [(ngModel)]="MeterDetails.meterId"
                          (focusout)="onMeterIDFocusOut()"
                          type="number"
                          required
                          placeholder="Meter ID"
                          (keypress)="numberOnly($event)"
                        />
                        <mat-error
                          *ngIf="isFieldHasError('meterIdCtr', 'required')"
                          >This field is required.</mat-error
                        >
                        <mat-error
                          *ngIf="isFieldHasError('meterIdCtr', 'duplicated')"
                          >Duplicated for site {{ MeterDetails.siteId }}.
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="col-lg-1"></div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-label class="label-input"
                        >Current Unbalance Y</mat-label
                      >
                    </div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="currentUnbalanceYCtr"
                          [(ngModel)]="MeterDetails.currentUnbalanceY"
                          placeholder="Enter Current Unbalance Y for Meter"
                          pattern="^(\d*\.)?\d+$"
                        />
                        <mat-error
                          *ngIf="
                            isFieldHasError('currentUnbalanceYCtr', 'pattern')
                          "
                        >
                          Please input positive decimal numbers.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >Hardware Version</mat-label
                      >
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="hardwareVersionCtr"
                          [(ngModel)]="MeterDetails.hardwareVersion"
                          placeholder="Hardware Version"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-3 col-sm-3">
                      <mat-label class=""
                        >Include for calculation in reports?</mat-label
                      >
                    </div>
                    <div class="col-lg-1 col-sm-1">
                      <mat-checkbox
                        formControlName="toIncludeCtr"
                        [(ngModel)]="MeterDetails.toInclude"
                        #showButtons
                      ></mat-checkbox>
                    </div>

                    <div class="col-lg-1"></div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-label class="label-input"
                        >System Voltage<span class="iep-required"
                          >*</span
                        ></mat-label
                      >
                    </div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-form-field>
                        <mat-select
                          formControlName="selectedSystemVCtr"
                          [(ngModel)]="selectedSystemV"
                          (selectionChange)="selectSystemV()"
                          placeholder="Please select System Voltage"
                          style="top: 12px"
                        >
                          <mat-option value="" selected
                            >Please select System Voltage</mat-option
                          >
                          <mat-option
                            *ngFor="let item of systemVoltages"
                            [value]="item"
                          >
                            {{ item }}</mat-option
                          >
                        </mat-select>
                        <mat-error
                          *ngIf="isFieldHasError('meterRoleCtr', 'required')"
                          >This field is required.</mat-error
                        >
                      </mat-form-field>
                    </div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="
                        MeterDetails.meterRole === CONST_Harmonic &&
                        MeterDetails.selectedSystemV === CONST_lessThan33kV
                      "
                    >
                      <mat-form-field>
                        <input
                          type="text"
                          matInput
                          formControlName="systemVCtr"
                          [(ngModel)]="MeterDetails.systemV"
                          placeholder="Enter System Voltage for Meter"
                          pattern="^(\d*\.)?\d+$"
                        />
                        <mat-error
                          *ngIf="isFieldHasError('systemVCtr', 'pattern')"
                          >Please input positive decimal numbers.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2"></div>
                    <div class="col-lg-2 col-sm-2"></div>

                    <div class="col-lg-1"></div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-label class="label-input">Neutral I Limit</mat-label>
                    </div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-form-field>
                        <input
                          type="text"
                          matInput
                          formControlName="neutralILimitCtr"
                          [(ngModel)]="MeterDetails.neutralILimit"
                          placeholder="Enter Neutral I Limit for Meter"
                          pattern="^(\d*\.)?\d+$"
                        />
                        <mat-error
                          *ngIf="isFieldHasError('neutralILimitCtr', 'pattern')"
                          >Please input positive decimal numbers.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2"></div>
                    <div class="col-lg-2 col-sm-2"></div>

                    <div class="col-lg-1"></div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-label class="label-input">Max P Limit</mat-label>
                    </div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-form-field>
                        <input
                          type="text"
                          matInput
                          formControlName="maxPLimitCtr"
                          [(ngModel)]="MeterDetails.maxPLimit"
                          placeholder="Enter Max P Limit for Meter"
                          pattern="^(\d*\.)?\d+$"
                        />
                        <mat-error
                          *ngIf="isFieldHasError('maxPLimitCtr', 'pattern')"
                          >Please input positive decimal numbers.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2"></div>
                    <div class="col-lg-2 col-sm-2"></div>

                    <div class="col-lg-1"></div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-label class="label-input"
                        >Power Loss Limit
                      </mat-label>
                    </div>
                    <div
                      class="col-lg-2 col-sm-2"
                      *ngIf="MeterDetails.meterRole === CONST_Harmonic"
                    >
                      <mat-form-field>
                        <input
                          type="text"
                          matInput
                          formControlName="harmonicPowerLossLimitCtr"
                          [(ngModel)]="MeterDetails.harmonicPowerLossLimit"
                          placeholder="Enter Harmonic Power Loss Limit for Meter"
                          pattern="^(\d*\.)?\d+$"
                        />

                        <mat-error
                          *ngIf="
                            isFieldHasError(
                              'harmonicPowerLossLimitCtr',
                              'pattern'
                            )
                          "
                        >
                          Please input positive decimal numbers.</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-1"></div>
                  <div class="col-lg-5">
                    <div></div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <button
                        bciprimarybutton
                        class="button-primary"
                        type="submit"
                        [disabled]="
                          !addMeterForm.valid || MeterDetails.submitted
                        "
                      >
                        <span>
                          <mat-icon
                            aria-hidden="false"
                            aria-label="weather icon"
                            class="bosch-ic-checkmark-frame"
                            style="width: max-content"
                          >
                          </mat-icon>
                        </span>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
